import { fetcher } from '@commenda/utils';
import { ComplianceStatus } from '@prisma/client';

export async function updateExtensionForCompliance({
  complianceItemId,
  data,
}: {
  complianceItemId: string;
  data: {
    status: ComplianceStatus;
  };
}) {
  const res = await fetcher(`compliance/${complianceItemId}/extension`, {
    method: 'PUT',
    body: data,
  });

  return res.json();
}
